import React from 'react';
import { PageHero } from '../components/PageHero';
import { SectionStage } from '../components/SectionStage';
export function Demo() {
  return <>
      <PageHero eyebrow="Product Demo" title="See the loop" titleMuted="in action." description="Watch how Periscan connects, validates, gathers evidence, recommends fixes, verifies closure, and generates reports. No form required." bg="none" data-id="element-1471" />

      <SectionStage fx="spotlight" data-id="element-1472">
        <section className="relative w-full py-32 border-t border-white/5" data-id="element-1473">
          <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-1474">
            <div className="aspect-video bg-[#070a0e] border border-white/10 rounded-2xl flex items-center justify-center" data-id="element-1475">
              <p className="text-white/40 font-mono text-sm uppercase tracking-widest" data-id="element-1476">
                [Two-minute product demo video]
              </p>
            </div>
          </div>
        </section>
      </SectionStage>
    </>;
}